// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		// Anchor links 
		window.addEventListener("hashchange", function () {
			window.scrollTo(window.scrollX, window.scrollY - 120);
		});

		if($(".two_cards").length > 0){
			setTimeout(function(){
				$( ".two_cards .two_cards__item" ).each(function() {
					$(this).on("click", function(e){
						console.log(this);
						if($(this).hasClass("active")){
							$(this).removeClass("active");
						}else{
							$(this).addClass("active");
						}
					});
				});
			}, 100);
		}

		//Custom form Dates
		$('#requestforproposal-form #id_8_1936[type="text"]').datepicker({ 
			onSelect: function(value, date) { 
			var miniDate = new Date(value);
			$('#id_9_1936').datepicker("option", 'minDate', miniDate);
			} 
		});

		$('#requestforproposal-form #id_11_1936[type="text"]').datepicker({ 
			onSelect: function(value, date) { 
			var miniDate = new Date(value);
			$('#id_12_1936').datepicker("option", 'minDate', miniDate);
			} 
		});
		
		//tablet menu
		if(document.getElementById('tabletBurger')){
			document.getElementById('tabletBurger').addEventListener('click', function(){
				if(!document.getElementById('primary-nav').classList.contains('open')){
					document.getElementById('primary-nav').classList.add('open');
					this.classList.add('open')
				} else {
					document.getElementById('primary-nav').classList.remove('open');
					this.classList.remove('open')
				}
			});
		}
		
		// Desplegable menu MOBILE
		// Open
		$(" #mobile-menu-button ").on("click", function(e){
			e.preventDefault();
			$(this).addClass('opened');
			$('.mobile-navigation').addClass('opened');
		});
		// Close
		$(" #close-menu ").on("click", function(e){
			e.preventDefault();
			$('#mobile-menu-button').removeClass('opened');
			$('.mobile-navigation').removeClass('opened');
		});

		/* Location Overview */
		var locationDots = document.querySelectorAll('.locationMod_pin');
	
		$('.locationMod_list').on('beforeChange', function(){
			locationDots.forEach( pin=>{
				pin.classList.remove('active');
			});
		});
		$('.locationMod_list').on('afterChange', function(a,b,c){
			let selectorString = `#locationMod_pin-${c}`;
			document.querySelector(selectorString).classList.add('active');
		});
		
		if (document.getElementById('terms_btn')) {
			let btnTerms = document.getElementById('terms_btn');
			let termsInfo = document.getElementById('terms_info');
			let termsInfoHeight = termsInfo.getElementsByClassName('wrap')[0].clientHeight;
			btnTerms.addEventListener('click', function(e) {
				e.preventDefault();
				termsInfo.classList.toggle('open');
				if (!this.classList.contains('active')) {
					this.classList.add('active');
					termsInfo.style.height = termsInfoHeight + 'px';
				} else {
					this.classList.remove('active');
					termsInfo.style.height = '0px';
				}
			});
		}

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});


		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	function agregarAriaLabel() {
		var signupButton = document.querySelector('.signup-btn');
	
		if (signupButton) {
			signupButton.setAttribute('aria-label', 'subscribe to our email database');
		}
	}
	
	document.addEventListener('DOMContentLoaded', function() {
		agregarAriaLabel();
	});

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let bodyId = document.getElementsByTagName('body')[0].id;
	if(st > 10 || document.getElementById('header').classList.contains('header_alt') ){

		// downscroll code
		if(!document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.add('down');
		}
		var logoUrl = site_url + 'assets/svg/indigo-scroll-new.svg';
		document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)
		
	} else {
		if(document.getElementById('header').classList.contains('header_alt') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('down');
		}
		var logoUrl = site_url + 'assets/svg/indigo-inn-logo.svg';
		document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}